import { render, staticRenderFns } from "./movementAccounts.vue?vue&type=template&id=1690b6b5"
import script from "./movementAccounts.vue?vue&type=script&lang=js"
export * from "./movementAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports